import ModalCloseIcon from './ModalCloseIcon';

export default ModalCloseIcon;
